import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["amount", "precision", "atomicSupply", "collateral", "status"];

  connect() {
    this.render();
  }

  render() {
    if (!this.hasAmountTarget) return;

    const rawAmount = this.amountTarget.value.trim();
    const precision = this.precisionTargets.find((input) => input.checked)?.value || "0";

    if (!/^\d+$/.test(rawAmount) || BigInt(rawAmount) <= 0n) {
      this.write(this.atomicSupplyTarget, "Enter a positive whole-token supply");
      this.write(this.collateralTarget, "—");
      this.write(this.statusTarget, "The chain carrier supply must be a positive whole number.");
      return;
    }

    const carrierUnits = BigInt(rawAmount);
    const decimals = precision === "18" ? 18n : 0n;
    const atomicSupply = carrierUnits * (10n ** decimals);

    this.write(this.atomicSupplyTarget, this.group(atomicSupply));
    this.write(this.collateralTarget, `${this.formatMaza(carrierUnits)} MAZA`);
    this.write(
      this.statusTarget,
      decimals === 18n
        ? "PB-18 records 18 decimal places at mint. Current on-chain checkout moves whole carrier tokens; atomic transfers stay locked until the PB-18 ledger is activated."
        : "PB-1 preserves today's whole-unit Pinball protocol."
    );
  }

  write(target, value) {
    if (target) target.textContent = value;
  }

  group(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatMaza(carrierUnits) {
    const denominator = 100000n;
    const whole = carrierUnits / denominator;
    const fractional = (carrierUnits % denominator).toString().padStart(5, "0").replace(/0+$/, "");

    return fractional ? `${this.group(whole)}.${fractional}` : this.group(whole);
  }
}
